import React from 'react';
import { Link } from "react-router-dom";
import SocialButtons from '../SocialButtons';

import i18n from '../../i18n';
import logo from '../../images/icon.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-transparent via-white/10 to-transparent"></div>
      </div>

      <div className="relative z-10">
        {/* Main footer content */}
        <div className="max-w-7xl mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            
            {/* Brand section */}
            <div className="col-span-1 lg:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <img
                  className="h-10 w-auto"
                  src={logo}
                  alt="Swami Ayurveda"
                />
                <span className="font-display text-2xl font-bold text-white">
                  Swami Ayurveda
                </span>
              </div>
              
              <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-md">
                Bringing ancient Ayurvedic wisdom to modern wellness. Experience personalized treatments designed to restore balance and harmony to your life.
              </p>
              
              <div className="mb-6">
                <SocialButtons light />
              </div>

              {/* Contact info */}
              <div className="space-y-2 text-sm text-gray-400">
                <div className="flex items-center space-x-2">
                  <span className="text-blue-400">📍</span>
                  <span>2021 Sperry Avenue Suite 18, Ventura, CA 93003</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-blue-400">✉️</span>
                  <a
                    href="mailto:tejal@swami.life"
                    className="text-gray-300 hover:text-white transition-colors no-underline"
                  >
                    tejal@swami.life
                  </a>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-blue-400">⏰</span>
                  <span>By Appointment Only</span>
                </div>
              </div>
            </div>

            <div></div>
            {/* Quick Links */}
            <div>
              <h3 className="font-display text-xl font-semibold mb-6 text-white">
                Quick Links
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link 
                    className="text-gray-300 hover:text-white transition-colors no-underline flex items-center group" 
                    to="/"
                  >
                    <span className="group-hover:translate-x-1 transition-transform">Home</span>
                  </Link>
                </li>
                <li>
                  <Link 
                    className="text-gray-300 hover:text-white transition-colors no-underline flex items-center group" 
                    to="/about"
                  >
                    <span className="group-hover:translate-x-1 transition-transform">About Us</span>
                  </Link>
                </li>
                <li>
                  <Link 
                    className="text-gray-300 hover:text-white transition-colors no-underline flex items-center group" 
                    to="/services"
                  >
                    <span className="group-hover:translate-x-1 transition-transform">Services</span>
                  </Link>
                </li>
                <li>
                  <a 
                    className="text-gray-300 hover:text-white transition-colors no-underline flex items-center group" 
                    href="mailto:tejal@swami.life"
                  >
                    <span className="group-hover:translate-x-1 transition-transform">Contact Us</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Newsletter section */}
          <div className="border-t border-gray-700 mt-12 pt-8">
            <div className="text-center max-w-2xl mx-auto">
              <h3 className="font-display text-2xl font-semibold mb-4 text-white">
                Stay Connected to Wellness
              </h3>
              <p className="text-gray-300 mb-6 text-center">
                Get Ayurvedic wellness tips, seasonal health advice, and exclusive offers delivered to your inbox.
              </p>
              
              {/* CTA Button */}
              <a
                href="https://www.fresha.com/providers/swami-ayurveda-ia5mxbwa?allOffer=true"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full transition-all duration-200 transform hover:scale-105 shadow-lg no-underline"
              >
                Book Your First Session
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700">
          <div className="max-w-7xl mx-auto px-4 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-gray-400 text-sm">
                Copyright © {new Date().getFullYear()} {i18n.swami_ayurveda}. All rights reserved.
              </div>
              
              <div className="flex items-center space-x-6 text-sm text-gray-400">
                <span className="flex items-center space-x-2">
                  <span className="text-green-400">🌿</span>
                  <span>Certified Ayurvedic Practitioner</span>
                </span>
                <span className="hidden sm:block">•</span>
                <span className="flex items-center space-x-2">
                  <span className="text-yellow-400">📍</span>
                  <span>Ventura, CA</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
